import React from 'react'

export default function NotAllowed() {
    return (
        <div>You are not allowed to see this page</div>
    )
}
